// api/zoom
export const GET_USER_PATH = '/api/zoom/get_user';
export const GET_ZOOM_USER_PATH = '/api/zoom/get_zoom_user_data';
export const GET_CLASS_INFO_PATH = '/api/zoom/get_class_info';
export const GET_CLASS_DATA_PATH = '/api/zoom/get_class_data';
export const GET_CLASS_DATA_DATA_PORTAL_PATH = '/api/zoom/get_class_data_data_portal';
export const SCHOOL_INFO = '/api/zoom/get_school_info';
export const GET_STUDENT_FOR_CODE = '/api/zoom/get_class_student_for_verification_code';

// api/recordings
export const LEGACY_RECORDINGS_LIST = '/meeting/{meetingId}/get_legacy_recordings';
export const RECORDINGS_LIST = '/recording/v1/schools/{schoolUuid}/class/{classUuid}/recordings';
export const RECORDING_INFORMATION = `${RECORDINGS_LIST}/{recordingUuid}`;
export const RECORDING_ARTIFACTS = `${RECORDING_INFORMATION}/artifacts`;
export const RECORDING_PATCH = `${RECORDINGS_LIST}/{recordingId}`;
export const RECORDING_DELETE = RECORDING_PATCH;
export const RECORDING_CLASS_USAGE = '/recording/v1/schools/{schoolUuid}/class/{classUuid}/usage';
export const RECORDING_USAGE = '/recording/v1/schools/{schoolUuid}/usage';

// lti
export const GET_LMS_AUTH = '/v1/lti/{lmsType}/lms_auth';
export const GET_LTI_CREDENTIAL_LIST = '/v1/lti/credential-all';
export const GET_LTI_CREDENTIAL = '/v1/lti/credential';
export const UPSERT_LTI_CREDENTIAL = '/v1/lti/credential';
export const DELETE_LTI_CREDENTIAL = '/v1/lti/credential';
export const REGENERATE_SHARED_SECRET = '/v1/lti/regenerate-credential-secret';
export const CREATE_LTI_CODE = '/v1/lti/code';
export const LMS_ADMIN = '/v1/lti/{lmsType}/lms_admin';
export const GET_LMS_SYNC_RESULTS = '/v1/lti/{classUuid}/lms_sync_results';

// auth
export const AUTH_ME = '/v1/auth/me';
export const LOGIN = '/v1/auth/login';
export const PASSWORD_RESET = '/v1/auth/passwords';
export const CREATE_USER = '/v1/auth/users';
export const VALIDATE_EMAIL = '/v1/auth/validate-email';
export const PASSWORD_RESET_REQUEST = '/v1/auth/password-reset-request';
export const PASSWORD_RESET_TOKEN_VERIFICATION = '/v1/auth/password-reset-token';
export const SSO_CONFIG_PATH = '/v1/auth/sso_config';
export const OIDC_LOGIN_REDIRECT_PATH = (oidcId: string): string => `/v1/auth/oidc/${oidcId}/redirect`;

// oauth
export const ZOOM_LOGIN_REDIRECT_PATH = '/api/zoom/zoom_redirect';
export const MICROSOFT_LOGIN_REDIRECT_PATH = '/v1/oauth/microsoft/redirect';

//oauth for corp lms integration
export const OAUTH_CORP_LMS = '/v1/lti-launch/oauth-authorize-redirect';
// users
export const USERS = '/v1/users';
export const USERS_DATA_PORTAL = '/v1/users_data_portal';
export const STUDENT = '/v1/users/student';

// templates
export const MOODLE_TEMPLATE_URL = '/v1/templates/moodle-template-url';
export const TEMPLATES_GET = '/v1/templates/template-get';
export const TEMPLATES_CREATE = '/v1/templates/template-create';
export const TEMPLATES_UPDATE = '/v1/templates/template-update';
export const TEMPLATES_DELETE = '/v1/templates/template-delete';

// api/admin
export const ADMIN_SETTINGS = '/api/admin/settings';

// v1/api-keys
export const API_KEYS_GET = '/v1/api-keys/get';
export const API_KEYS_CREATE = '/v1/api-keys/create';
export const API_KEYS_REGENERATE = '/v1/api-keys/regenerate';
export const API_KEYS_UPDATE = '/v1/api-keys/update';
export const API_KEYS_DELETE = '/v1/api-keys/delete';

// dashboard
export const GET_USER_PROFILE_DATA = '/extra_long_api/dashboards/get_user_profile_data';
export const GET_ENROLLED_CLASSES_STUDENT = '/extra_long_api/dashboards/get_enrolled_classes_student';
export const GET_ENROLLED_CLASSES_TEACHER = '/extra_long_api/dashboards/get_classes_teacher';
export const GET_CLASS_DASHBOARD_DATA = '/extra_long_api/dashboards/get_class_dashboard_data';
export const GET_CLASS_SESSION_ZOOM_STATES = '/extra_long_api/dashboards/get_class_session_zoom_states';
export const GET_CLASS_SESSION_DASHBOARD_DATA = '/extra_long_api/dashboards/get_class_session_dashboard_data';
export const GET_CLASS_SESSION_CONTENT = '/extra_long_api/dashboards/get_class_session_content';
export const GET_STUDENT_DASHBOARD_DATA = '/extra_long_api/dashboards/get_student_dashboard_data';
export const GET_TEACHER_DASHBOARD_DATA = '/extra_long_api/dashboards/get_teacher_dashboard_data';
export const GET_USER_DATA = '/extra_long_api/dashboards/get_teacher_dashboard_data';
export const GET_HOME_PAGE_DATA = '/extra_long_api/dashboards/get_home_page_data';
export const GET_CLOUDWATCH_LOGS = '/extra_long_api/dashboards/get_cloudwatch_logs';
export const GET_ERRORS = '/extra_long_api/dashboards/get_errors';
export const RUN_AI_MODEL_FOR_CLASS_SESSION = '/extra_long_api/dashboards/run_ai_model_for_class_session';
export const GET_PARTICIPANT_LOGS = '/extra_long_api/dashboards/get_participant_logs';

// v1/class
export const CLASS_INFO = '/v1/class';
export const CLASS_INFO_DATA_PORTAL = '/v1/class_data_portal';
export const CLASS_CREATE = CLASS_INFO;
export const CLASS_UPDATE = CLASS_INFO;
export const CLASS_DELETE = CLASS_INFO;
export const CLASS_ME = '/v1/class/me';
export const CLASS_SUB_CLASSES = '/v1/class/{classId}/sub_classes';
export const CLASS_PUBLISH = '/v1/class/publication';
export const CLASS_METRICS = '/v1/class/metrics';
export const CLASS_SESSIONS = '/v1/class/sessions';
export const CLASS_STUDENTS = '/v1/class/students';
export const CLASS_STUDENTS_DATA_PORTAL = '/v1/class/students_data_portal';
export const INVITE_STUDENTS_API = '/v1/class/invite';
export const CLASS_ATTENDANCE = '/v1/class/attendance';
export const CLASS_PERMISSIONS = '/v1/class/permissions';
export const CLASS_CALENDAR = '/v1/class/calendar';
export const CLASS_CALENDAR_EMAIL = '/v1/class/calendar/email';
export const CLASSES = '/v1/classes';
export const CLASSES_DATA_PORTAL = '/v1/classes_data_portal';
export const UPDATE_CLASS_MEETING = '/extra_long_api/zoom/update_class_meeting';
export const GET_CLASS_USER_SESSION_DATA_PATH = '/v1/class/{classId}/session/{sessionUuid}';
export const GET_MERGED_CLASS_SETTINGS = '/api/admin/settings/class';
// v1/locale
export const LOCALE_API = '/v1/locale';

// LTI 1.3
export const LTI_REDIRECT_URI = '/v1/lti-launch/redirect';
export const LTI_KEYSET_URL = '/v1/lti-launch/jwks';
export const LTI_OIDC_URL = '/v1/lti-launch/oidc';

export const PROBLEM_REPORT_UPLOAD_URL = '/v1/problem-report-upload-url';

export const CLASS_LOGO_PATH = 'https://classedu.class.com/images/class-logo-full-color-rgb-313px@72ppi.png';
